<!-- @if (readonly) {
  <div class="floating-label-container">
      <div style="position:relative; border:1px solid #dddddd;  border-radius: 4px; padding:0px;">
          <textarea style="padding:7px 0px 7px 7px;" [disabled]="true" [class]="this.type == TextModes.CurrencyUSD || this.type == TextModes.Percent ? 'floatTextExtraPadding' : ''" [(ngModel)]="boundValue" [style.width.%]="control_width_pct" [style.width.px]="control_width_px"></textarea>
      </div>
      <div class="floatLabel">{{label}}</div>
  </div>
  } -->
    
  <div class="form-input-container" [style]="style">
      <label>{{label}}</label>

      <!-- TODO: padding-left should be conditional based on whether there's left overlay or right overlay -->
      <div style="position:relative;">
          <div style="position:relative; align-items: center;">
            <textarea id="{{ myId }}" #inputControl class="floatText" rows="{{ rows }}" cols="{{ cols }}" [disabled]="readonly" [(ngModel)]="boundValue" (keyup)="_handle_onKeyUp($event)" [style]="style" [style.width.%]="control_width_pct" [style.width.px]="control_width_px" (blur)="handle_onBlur($event)"></textarea>
            <!-- <textarea [value]="defaultText" [placeholder]="hint" [disabled]="disabled" [class.is-invalid]="!isValid" class="form-input floatText" [attr.tid]="testId" id="{{myId}}" #textbox [(ngModel)]="boundValue" (keyup)="_handle_onKeyUp($event)" [style.width.%]="control_width_pct" [style.width.px]="control_width_px" (blur)="handle_onBlur($event)"></textarea> -->
          </div>
          @if (helpText != '') {
              <mat-icon
              class="iconOverlay"
              matTooltip="{{ helpText }}"
              [ngStyle]="{ color: '#6b7475' }"
              >info</mat-icon
            >
          }
          <div class="validation-msg" [hidden]="isValid">{{validationMsg}}</div>
      </div>    
  </div>